import { MutableRefObject, useEffect, useRef } from "react";

export const ReactHTMLElement: React.FC<{ html: HTMLElement }> = ({ html }) => {
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    if (!ref?.current) {
      return;
    }

    // clear all children
    ref.current.innerHTML = "";

    ref.current.appendChild(html);
  }, [html]);

  return <div ref={ref as MutableRefObject<HTMLDivElement>}></div>;
};
